import { Injectable } from "@angular/core";
import { ChecklistTemplateVersion } from "../../models/checklist-template/checklist-template-version";
import { Action, Selector, State, StateContext, Store } from "@ngxs/store";
import { throwError } from "rxjs";
import { ChecklistTemplateVersionReleasedClassesAction } from "./checklist-template-version-released-classes.action";
import { CompoApp } from "../../services/CompoApp";
import { Observable } from "rxjs/internal/Observable";
import { CompoClass } from "../../models/component_class/CompoClass";
import {
  ChecklistTemplateVersionReleasedClassesRequestService
} from "../../services/request/checklist-template-version-released-classes-request.service";
import {
  BaseReleasedClassesStateModel,
  BaseReleasedClassesXsState
} from "../base/released-classes/base-released-classes-xs.state";
import { ChecklistTemplateDetailAction } from "../checklist-template/checklist-template-detail.action";
import { ClassTreeNode } from "../../models/frontend_entities/ClassTreeNode";
import { ChecklistTemplateDetailMenu } from '../../enums/checklist-template/checklist-template-detail-menu.enum';

interface ChecklistTemplateVersionReleasedClassesStateModel extends BaseReleasedClassesStateModel {
  selectedVersion: ChecklistTemplateVersion;
}

const getDefaults = (initSelection?: Set<string>, currentSelection?: Set<string>):ChecklistTemplateVersionReleasedClassesStateModel  => ({
  ...BaseReleasedClassesXsState.getDefaults(initSelection, currentSelection),
  selectedVersion: null,
});

@State<ChecklistTemplateVersionReleasedClassesStateModel>({
  name: 'checklistTemplateVersionReleasedClasses',
  defaults: getDefaults()
})
@Injectable()
export class ChecklistTemplateVersionReleasedClassesXsState extends BaseReleasedClassesXsState {

  constructor(private app: CompoApp,
              private store: Store,
              private requestService: ChecklistTemplateVersionReleasedClassesRequestService) {
    super();
  }

  protected getCompoClassTree(): Promise<CompoClass[]>{
    return this.app.classService.getClassTreeForOrg(this.app.data.getUser().organization.id);
  }
  protected performSave(state: ChecklistTemplateVersionReleasedClassesStateModel): Observable<any> {
    const templateId = state.selectedVersion.checklistTemplateId;
    const versionId = state.selectedVersion.id;
    const selection = [...state.currentSelection];

    return this.requestService.saveSelection(templateId, versionId, selection);
  }

  protected postSave(state: ChecklistTemplateVersionReleasedClassesStateModel, resp?: any): void {
    const templateId = state.selectedVersion.checklistTemplateId;
    this.store.dispatch(new ChecklistTemplateDetailAction.Fetch(templateId));
    this.store.dispatch(new ChecklistTemplateDetailAction.SetSelectedMenu(ChecklistTemplateDetailMenu.RELEASED_CLASSES));
  }

  @Selector()
  static classTree(state: ChecklistTemplateVersionReleasedClassesStateModel): ClassTreeNode[] | null {
    return super.classTree(state);
  }

  @Selector()
  static requestInProgress(state: ChecklistTemplateVersionReleasedClassesStateModel): boolean{
    return super.requestInProgress(state);
  }

  @Selector()
  static selection(state: ChecklistTemplateVersionReleasedClassesStateModel): Set<string> | null {
    return super.selection(state);
  }

  @Selector()
  static selectionOnlyLeafs(state: ChecklistTemplateVersionReleasedClassesStateModel): Set<string> | null {
    return super.selectionOnlyLeafs(state);
  }

  @Selector()
  static allClassIds(state: ChecklistTemplateVersionReleasedClassesStateModel): string[] {
    return super.allClassIds(state);
  }

  @Selector()
  static classReleaseInProgress(state: ChecklistTemplateVersionReleasedClassesStateModel): boolean {
    return super.classReleaseInProgress(state);
  }

  @Selector()
  static saveRequired(state: ChecklistTemplateVersionReleasedClassesStateModel): boolean {
    return super.saveRequired(state);
  }


  @Action(ChecklistTemplateVersionReleasedClassesAction.Initialize)
  public initialize(ctx: StateContext<ChecklistTemplateVersionReleasedClassesStateModel>,
                    action: ChecklistTemplateVersionReleasedClassesAction.Initialize): Observable<void>  {
    if (!action.version) {
      return throwError(() => new Error('No checklist template version is present!'));
    }

    const initialSelection =  new Set<string>(action.version.releasedClasses);
    const currentSelection = new Set<string>(action.version.releasedClasses);

    ctx.patchState({
      ...getDefaults(initialSelection, currentSelection),
      selectedVersion: action.version,
      inProgress: true
    });

    // @ts-ignore
    return this.initSelection(ctx);
  }

  @Action(ChecklistTemplateVersionReleasedClassesAction.ChangeSelection)
  public change(ctx: StateContext<ChecklistTemplateVersionReleasedClassesStateModel>,
                    action: ChecklistTemplateVersionReleasedClassesAction.ChangeSelection): void  {
    if (!action.ids) {
      throwError(() => new Error('No ids provided to for the selection!'));
      return;
    }
    // @ts-ignore
    return this.changeSelection(ctx,action.ids);
  }

  @Action(ChecklistTemplateVersionReleasedClassesAction.Save)
  public save(ctx: StateContext<ChecklistTemplateVersionReleasedClassesStateModel>,
                         action: ChecklistTemplateVersionReleasedClassesAction.Save): Observable<void>  {
    const state = ctx.getState();
    if (!state.selectedVersion) {
      return throwError(() => new Error('No version provided'));
    }

    // @ts-ignore
    return this.saveSelection(ctx);
  }

  @Action(ChecklistTemplateVersionReleasedClassesAction.ResetToInitialSelection)
  public reset(ctx: StateContext<ChecklistTemplateVersionReleasedClassesStateModel>,
              action: ChecklistTemplateVersionReleasedClassesAction.ResetToInitialSelection): void {
     // @ts-ignore
    return this.resetSelection(ctx);
  }
}
